import { render, staticRenderFns } from "./CompanyProjectsCard.vue?vue&type=template&id=0ea50d33&"
import script from "./CompanyProjectsCard.vue?vue&type=script&lang=js&"
export * from "./CompanyProjectsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports